import { api_GET, api_POST, api_PUT } from "./_api.js";

const planoTrabalho_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`PlanoTrabalho/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`PlanoTrabalho/getItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`PlanoTrabalho`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`PlanoTrabalho`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default planoTrabalho_api;
